/* eslint-disable @typescript-eslint/no-explicit-any */
// src/redux/products/thunk.ts

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '@/utils/apiClient';
import { GetProductItemPayload, ProductItemResponse } from './types';

export const fetchProductItem = createAsyncThunk<
  ProductItemResponse,
  GetProductItemPayload,
  { rejectValue: string }
>('products/fetchItem', async (payload, { rejectWithValue }) => {
  try {
    const response = await apiClient('/data/api/v1/products/item/', {
      method: 'POST',
      body: payload,
    });

    return response as ProductItemResponse;
  } catch (err: any) {
    return rejectWithValue(
      err?.message || 'Failed to fetch product item details'
    );
  }
});
